import React, { Component, Suspense } from "react";
import { Translation } from "react-i18next";
import { Router, Route, Switch, Redirect, withRouter } from "react-router-dom";
import "./App.scss";
import "./assets/img/logo-fav.svg";
import Loading from "./Loading/Loading";
import InstallPage from "./Components/InstallPage";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Suspense fallback={<Loading />}>
        <Translation>
          {(t, { i18n }) => {
            const changeLanguage = lng => {
              i18n.changeLanguage(lng);
              console.log(lng);
            };
            const lang = localStorage.getItem("i18nextLng");
            return (
              <Switch>
                <Redirect exact from="/" to={"/all"} />
                <Route
                  exact
                  path="/:filter"
                  render={props => (
                    <InstallPage
                      t={t}
                      {...props}
                      changeLanguage={changeLanguage}
                    />
                  )}
                />
              </Switch>
            );
          }}
        </Translation>
      </Suspense>
    );
  }
}

export default App;
